import React from "react";
import profilephoto from "../img/profilephoto.jpg";

const About = () =>{
    return (
        <section className="about" id="about">
            <div className="title">
                <h3>About</h3>
            </div>
            <div className="description">
                <p>Me considero una persona proactiva, metódica, optimista,
                    resolutiva y con gran capacidad de adaptación al cambio y
                    trabajo en equipo. Toda mi experiencia laboral ha estado
                    orientada a la atención al cliente y gestión de equipos, pero
                    lo que verdaderamente me apasiona es la programación.
                    Busco nuevos retos profesionales que me permitan
                    evolucionar y crecer</p>
            </div>
            <figure>
                <img src={profilephoto} alt="fotoPerfil"/>
            </figure>
            <div className="datas_aboutme">
                <div>
                    <i class="fa-solid fa-phone"></i><p>670 88 53 22</p>
                </div>
                <div>
                    <i class="fa-solid fa-location-dot"></i><p>Donostia - San Sebastian</p>
                </div>
                <div>
                    <i class="fa-solid fa-envelope"></i><p>rjzambrano87@gmail.com</p>
                </div>
                <div>
                    <i class="fa-solid fa-globe"></i><p>www.jasio-dev.com</p>
                </div>
            </div>

        </section>
    );
}

export default About;